import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PriceCurrencyPipe } from '@/common/pipes/price-currency.pipe';
import { DriversSalaryV2StateService } from '../_services/drivers-salary-v2.state.service';

@Component({
	selector: 'app-salary-settlement-bonuses',
	standalone: true,
	imports: [
		CommonModule,
		RouterLink,
		MatButtonModule,
		MatCardModule,
		MatExpansionModule,
		MatListModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		PriceCurrencyPipe,
	],
	templateUrl: './salary-settlement-bonuses.component.html',
	styleUrl: './salary-shared.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalarySettlementBonusesComponent {
	readonly state = inject(DriversSalaryV2StateService);
}
